import Immutable from 'immutable';
import Coupon from './coupon';
import { hasUrlString, getUrlString } from '../utils/urlUtil';

const CouponCardRecord = Immutable.Record({
  id: 0,
  type: 'couponCard',
  coupon: new Coupon()
});

class CouponCard extends CouponCardRecord {
  get contents() {
    const { content } = this.coupon;

    return hasUrlString(content) ?
      content.split(new RegExp(`(${getUrlString(content).join('|')})`, 'g'))
      .map((e) => (hasUrlString(e) ? Immutable.fromJS({t: "link", v: e}) : Immutable.fromJS({t: "text", v: e})))
      : Immutable.fromJS([{ t: "text", v: content }]);
  }
}

export default CouponCard;



// WEBPACK FOOTER //
// ./src/models/couponCard.js